import { shopService } from "../services/shop/index1";
import fileServices from "../services/storage/index1";
import { message } from "antd";
import { has, omit } from "lodash";
import { isDeepEqual } from "../utils";
import taxService from "../services/tax";
import { data } from "browserslist";
import { removeImageSizePrefix } from "../utils/image";
import { localErrorHandler } from "../utils/errorHandler";
import { isNoAnswer } from "../services/offline/serverReach";
import { readCopy, saveCopy } from "../services/offline/offlineCopy";

const namespace = "shop";

const initialState = {
  data: undefined,
  loading: {
    fetch: false,
    update: false,
  },
};

export const fetch = (shopId) => ({
  type: `${namespace}/fetch`,
  payload: shopId,
});

export const update = (data) => ({
  type: `${namespace}/update`,
  payload: data,
});

export default {
  namespace,
  state: initialState,
  effects: {
    *fetch({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetch" });
      try {
        const response = yield call(shopService.fetch, payload);
        saveCopy(`shop:${payload}`, response.data);
        yield put({
          type: "setShop",
          payload: response.data,
        });
      } catch (error) {
        console.error("Error fetching shop:", error);
        // no internet: the shop saved on this device, so the POS still opens
        const copy = isNoAnswer(error)
          ? readCopy(`shop:${payload}`)
          : undefined;
        if (copy) yield put({ type: "setShop", payload: copy });
      }
      yield put({ type: "stopLoading", loadingType: "fetch" });
    },
    *update({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "update" });
      try {
        if (payload.taxes && payload.taxes.length > 0) {
          yield call(taxService.update, { taxes: payload.taxes });
        }

        if (
          isDeepEqual(payload.cover_image[0].src, payload.old_cover_image_url)
        ) {
          payload.cover_image =
            removeImageSizePrefix(payload.old_cover_image_url) ?? "";
        } else {
          const { url } = yield call(fileServices.uploadFile, {
            file: payload.cover_image[0],
            img_sizes: ["medium", "large"],
            model: "shops",
            id: payload.id,
            img_field: "cover_image",
          });
          payload.cover_image = url;
          if (payload.old_cover_image_url)
            yield call(
              fileServices.deleteFile,
              removeImageSizePrefix(payload.old_cover_image_url),
            );
        }

        if (
          isDeepEqual(
            payload.profile_image[0].src,
            payload.old_profile_image_url,
          )
        ) {
          payload.profile_image =
            removeImageSizePrefix(payload.old_profile_image_url) ?? "";
        } else {
          const { url } = yield call(fileServices.uploadFile, {
            file: payload.profile_image[0],
            img_sizes: ["small", "medium"],
            model: "shops",
            id: payload.id,
            img_field: "profile_image",
          });

          payload.profile_image = url;
          if (payload.old_profile_image_url)
            yield call(
              fileServices.deleteFile,
              removeImageSizePrefix(payload.old_profile_image_url),
            );
        }

        payload.delievery_fees = {
          delievery_fees: payload.delievery_fees,
        };
        const updates = {
          ...omit(payload, [
            "old_cover_image_url",
            "old_profile_image_url",
            "taxes",
            "id",
          ]),
        };

        const response = yield call(shopService.update, updates);
        yield put({
          type: "updateShop",
          payload: response.data,
        });
        message.success("Shop data updated");
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "update" });
      }
      yield put({ type: "stopLoading", loadingType: "update" });
    },
  },
  reducers: {
    setShop(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
    updateShop(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
    clearShop(state) {
      return {
        ...state,
        data: undefined,
      };
    },
    startLoading(state, { loadingType }) {
      return {
        ...state,
        loading: { ...state.loading, [loadingType]: true },
      };
    },
    stopLoading(state, { loadingType }) {
      return {
        ...state,
        loading: { ...state.loading, [loadingType]: false },
      };
    },
  },
};
